<template>
  <div class="container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>个人公益成果提报</span>
      </div>
    </div>
    <div class="form">
      <div class="fild_label">
        <span></span>
        <div>员工姓名</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.nickname"
          placeholder="请输入员工姓名"
          disabled
        />
      </div>
      <div class="fild_label">
        <span></span>
        <div>工号</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.empNo"
          placeholder="请输入员工姓名"
          disabled
        />
      </div>
      <div class="fild_label">
        <span></span>
        <div>员工部门</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.department"
          placeholder="请输入员工姓名"
          disabled
        />
      </div>
      <!-- <div class="fild_label">
        <span>*</span>
        <div>个人公益类型</div>
      </div>
      <div class="fild_value">
        <el-select
          v-model="baseinfo.pbType"
          placeholder="请选择"
          @change="changeType"
        >
          <el-option
            v-for="item in optionType"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div> -->
      <div class="fild_label" v-if="baseinfo.pbType == 2">
        <span>*</span>
        <div>志愿服务类型</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 2">
        <van-radio-group v-model="baseinfo.assort" direction="horizontal">
          <van-radio name="社区志愿服务" style="font-size: 14px;">社区志愿服务</van-radio>
          <van-radio name="扶贫济困" style="font-size: 14px;">扶贫济困</van-radio>
          <van-radio name="支教助学" style="font-size: 14px;">支教助学</van-radio>
        </van-radio-group>
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 4">
        <span>*</span>
        <div>公益捐款类型</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 4">
        <van-radio-group v-model="baseinfo.assort" direction="horizontal">
          <van-radio name="公益基金会" style="font-size: 14px;">公益基金会</van-radio>
          <van-radio name="慈善机构" style="font-size: 14px;">慈善机构</van-radio>
        </van-radio-group>
      </div>
      <div class="fild_label">
        <span>*</span>
        <div>参加公益日期</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.enterTime"
          placeholder="请选择公益日期"
          readonly
          clickable
          @click="showPickerTwo = true"
        />
        <van-popup v-model="showPickerTwo" position="bottom">
          <van-datetime-picker
            type="date"
            v-model="currentTime"
            @confirm="onConfirmTwo"
            @cancel="showPickerTwo = false"
          />
        </van-popup>
      </div>
      <!-- <div class="fild_label" v-if="baseinfo.pbType == 3">
        <span>*</span>
        <div>参加公益日期</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 3">
        <van-field
          v-model="baseinfo.enterTime"
          placeholder="请选择公益日期"
          readonly
          clickable
          @click="showPickerTwo = true"
        />
        <van-popup v-model="showPickerTwo" position="bottom">
          <van-datetime-picker
            type="date"
            v-model="currentTime"
            @confirm="onConfirmTwo"
            @cancel="showPickerTwo = false"
          />
        </van-popup>
      </div> -->
      <!-- <div class="fild_label" v-if="baseinfo.pbType != 3">
        <span>*</span>
        <div>参加公益日期</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType != 3">
        <van-field
          v-model="baseinfo.enterTime"
          placeholder="请选择公益日期"
          disabled
        />
        <img
          src="../../../assets/newMedal/publicWelfare/add.png"
          alt=""
          @click="addClick"
        />
      </div>
      <div class="tagList" v-if="tagTimeList.length > 0 && baseinfo.pbType != 3">
        <div class="tag_item" v-for="(item, index) in tagTimeList" :key="index">
          <div>{{ item }}</div>
          <i class="el-icon-close" @click="delClick(index)"></i>
        </div>
      </div> -->
      <div class="fild_label" v-if="baseinfo.pbType == 1">
        <span>*</span>
        <div>献血量/ml</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 1">
        <van-field
          type="number"
          v-model="baseinfo.blood"
          placeholder="请输入献血量"
          @change="change1"
        />
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 2">
        <span>*</span>
        <div>公益时长</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 2">
        <van-field
          v-model="baseinfo.hour"
          placeholder="请输入公益时长"
          @change="change2"
        />
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 3">
        <span>*</span>
        <div>公益活动</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 3">
        <van-field
          v-model="baseinfo.departmentName"
          placeholder="请输入活动类型"
          @change="change3"
        />
        <!-- <el-select
          v-model="baseinfo.number"
          placeholder="请选择公益活动"
          @change="change3"
        >
          <el-option
            v-for="item in welfareList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
      </div>
      <div
        v-if="baseinfo.pbType == 3"
        style="font-size: 12px; color: #666; margin: -10px 0 10px"
      >
        例如：蚂蚁森林,美团公益,水滴公益
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 4">
        <span>*</span>
        <div>捐款金额/元</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 4">
        <van-field
          type="number"
          v-model="baseinfo.money"
          placeholder="请输入捐款金额"
          @change="change4"
        />
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 5">
        <span>*</span>
        <div>估算价值/元</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 5">
        <van-field
          type="number"
          v-model="baseinfo.money"
          placeholder="请输入估算价值"
          @change="change5"
        />
      </div>
      <div class="fild_label" v-if="baseinfo.pbType == 6">
        <span>*</span>
        <div>公益时长/h</div>
      </div>
      <div class="fild_value" v-if="baseinfo.pbType == 6">
        <van-field
          type="number"
          v-model="baseinfo.hour"
          placeholder="请输入公益时长"
          @change="change6"
        />
      </div>
      <div
        class="fild_label"
        v-if="baseinfo.pbType != 2 && baseinfo.pbType != 6"
      >
        <span></span>
        <div>换算公益时长/h</div>
      </div>
      <div
        class="fild_value"
        v-if="baseinfo.pbType != 2 && baseinfo.pbType != 6"
      >
        <van-field
          v-model="baseinfo.lngTime"
          placeholder="请输入换算公益时长"
          disabled
        />
      </div>
      <!-- <div class="fild_label">
        <span></span>
        <div>预计换算积分</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.points"
          placeholder="请输入换算积分"
          disabled
        />
      </div> -->
      <div class="fild_label">
        <span>*</span>
        <div>证明材料（限2024年1月1日后的公益活动）</div>
      </div>
      <div class="fild_value fild_value_upload">
        <el-upload
          :action="`${upload}/file/upload`"
          list-type="picture-card"
          :file-list="beforeImageList"
          :on-success="handleBeforeImage"
          accept=".jpg,.jpeg,.png"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="previewBeforeImage(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <!-- <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span> -->
            </span>
          </div>
        </el-upload>
      </div>
      <!-- <div class="message" style="font-size: 13px; color: #ccc">
        *提交公益成果证明资料，包括由有资质单位出具的线上或线下志愿服务时长证明、电子版献血证（针对无偿献血）、电子版公益捐款证明（如水滴筹）、物资捐赠证明以及指尖公益的电子版证明。
      </div> -->
      <div class="prove" v-if="baseinfo.pbType == 1">
        <div class="title">示例图：献血办公室颁发的献血证</div>
        <div class="img">
          <img
            @click="previewImg('prove1')"
            src="@/assets/newMedal/publicWelfare/prove1.png"
            alt=""
          />
        </div>
      </div>
      <div class="prove" v-if="baseinfo.pbType == 2">
        <div class="title">示例图：有资质机构颁发的志愿服务证书</div>
        <div class="img">
          <img
            @click="previewImg('prove2')"
            src="@/assets/newMedal/publicWelfare/prove2.png"
            alt=""
          />
        </div>
      </div>
      <div class="prove" v-if="baseinfo.pbType == 3">
        <div class="title">示例图：公益活动举办方颁发的捐步证书</div>
        <div class="img">
          <img
            @click="previewImg('prove3')"
            src="@/assets/newMedal/publicWelfare/prove3.png"
            alt=""
          />
        </div>
      </div>
      <div class="prove" v-if="baseinfo.pbType == 4">
        <div class="title">
          示例图：公益项目或慈善机构提供的捐赠证明
        </div>
        <div class="img">
          <!-- <img
            @click="previewImg('prove4')"
            src="@/assets/newMedal/publicWelfare/prove4.png"
            alt=""
          />
          <img
            @click="previewImg('prove5')"
            src="@/assets/newMedal/publicWelfare/prove5.png"
            alt=""
          /> -->
          <img
            @click="previewImg('prove6')"
            src="@/assets/newMedal/publicWelfare/prove6.png"
            alt=""
          />
        </div>
      </div>
      <div class="prove" v-if="baseinfo.pbType == 5">
        <div class="title">
          示例图：通过捐赠书籍、生活用品、学习用品等物资帮助受益人群的公益行为
        </div>
        <div class="img">
          <img
            @click="previewImg('prove7')"
            src="@/assets/newMedal/publicWelfare/prove7.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button class="btn1" @click="submit">确认</el-button>
      <el-button class="btn2" @click="no">取消</el-button>
    </div>
    <van-dialog
      v-model="showTime"
      title="添加时间"
      :show-cancel-button="false"
      :showConfirmButton="false"
    >
      <van-field
        readonly
        clickable
        name="datetimePicker"
        :value="valueTime"
        label="时间选择"
        placeholder="点击选择时间"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom" get-container="body">
        <van-datetime-picker
          type="date"
          v-model="currentTime"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <div class="dialog_footer">
        <el-button @click="cancal">取消</el-button>
        <el-button @click="addTime">确认</el-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showExamine"
      :show-cancel-button="false"
      :showConfirmButton="false"
    >
      <div class="dialog_header_con">
        <div class="left">提交审批</div>
        <van-icon name="cross" @click="cancleExamine" />
      </div>
      <div class="examine_con">
        <!-- <van-field
          readonly
          clickable
          :value="valueExamine"
          label="审批人"
          placeholder="请选择审批人"
          right-icon="arrow-down"
        /> -->
        <div class="con_tit">审批人</div>
        <div class="img_con">
          <img :src="examineInfo.icon" alt="" />
        </div>
        <div class="name">{{ examineInfo.nickname }}</div>
      </div>
      <div class="dialog_footer1">
        <el-button @click="cancleExamine">取消</el-button>
        <el-button @click="submitExamine">提交审批</el-button>
      </div>
    </van-dialog>
    <el-dialog :visible.sync="dialogVisibleImg" class="dialogImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment/moment";
import api from "@/apis/medal";
import apis from "@/apis/publicWelfare";
// import moment from 'moment/moment';
export default {
  name: "my",
  props: {},
  components: {},
  data() {
    return {
      dialogVisibleImg: false,
      dialogImageUrl: "",
      baseinfo: {
        nickname: "",
        empNo: "",
        department: "",
        pbType: "",
        enterTime: "",
        blood: "",
        money: "",
        hour: "",
        image: [],
        lngTime: "",
        points: "",
        departmentName: "",
        assort: "",
      },
      optionType: [],
      // welfareList: [],
      showTime: false,
      valueTime: "",
      showPicker: false,
      showPickerTwo: false,
      currentTime: new Date(),
      tagTimeList: [],
      beforeImageList: [],
      showExamine: false,
      valueExamine: "",
      examineInfo: {},
      upload: "",
    };
  },

  created() {},
  computed: {},
  mounted() {
    const { nickname, username, department } = this.$store.state.userInfo;
    this.baseinfo.nickname = nickname;
    this.baseinfo.empNo = username;
    this.baseinfo.department = department;
    this.getSelect();
    this.queryParentName();
    this.upload = api.upload;
  },
  beforeDestroy() {},
  methods: {
    //上传
    handleBeforeImage(file) {
      console.log(file, "file");

      this.baseinfo.image.push(file.id);
    },
    //删除
    handleRemove(file) {
      console.log(file, "file");
      console.log(this.beforeImageList, "this.beforeImageList;");

      const index = this.baseinfo.image.findIndex(
        (item) => file.response.id == item
      );

      if (index >= 0) {
        this.baseinfo.image.splice(index, 1);
        // this.$set(this.baseinfo, 'image', [...this.baseinfo.image])
        // this.$forceUpdate();
      }
      console.log(index, "index");
      console.log(this.baseinfo.image, "this.baseinfo.image");
    },
    // 图片放大预览
    previewBeforeImage(file) {
      this.dialogImageUrl = file.response
        ? api.imgUrl + file.response.id
        : file.url;
      this.dialogVisibleImg = true;
    },
    // 图片放大预览
    previewImg(path) {
      this.dialogImageUrl = require("@/assets/newMedal/publicWelfare/" +
        path +
        ".png");
      this.dialogVisibleImg = true;
      console.log(this.dialogImageUrl, "this.dialogImageUrl");
    },
    // 改变献血量
    change1() {
      const type = this.baseinfo.pbType;
      const index = this.optionType.find((item) => item.id == type);
      this.baseinfo.lngTime = (this.baseinfo.blood * index.coefficient).toFixed(
        2
      );
    },
    // 改变公益时长
    change2() {
      // const type = this.baseinfo.pbType;
      // const index = this.optionType.find((item) => item.id == type);
      this.baseinfo.lngTime = this.baseinfo.hour;
    },
    //改变活动类型
    change3() {
      const type = this.baseinfo.pbType;
      const index = this.optionType.find((item) => item.id == type);
      this.baseinfo.lngTime = index.coefficient;
    },
    // 改变捐款金额
    change4() {
      const type = this.baseinfo.pbType;
      const index = this.optionType.find((item) => item.id == type);
      this.baseinfo.lngTime = (this.baseinfo.money * index.coefficient).toFixed(
        2
      );
    },
    // 改变估算价值
    change5() {
      const type = this.baseinfo.pbType;
      const index = this.optionType.find((item) => item.id == type);
      this.baseinfo.lngTime = (this.baseinfo.money * index.coefficient).toFixed(
        2
      );
    },
    // 改变公益时长
    change6() {
      // const type = this.baseinfo.pbType;
      // const index = this.optionType.find((item) => item.id == type);
      this.baseinfo.lngTime = this.baseinfo.hour;
    },
    // 返回上一页
    goback() {
      this.$router.go(-1);
    },
    //获取个人公益类型
    getSelect() {
      apis.getTypeList().then((res) => {
        if (res.code == 200) {
          console.log(res, "res");
          this.optionType = res.data;
          this.optionType = this.optionType.filter(
            (item) => !["6"].includes(String(item.id))
          );
          const { type } = this.$route.query;
          this.baseinfo.pbType = Number(type);
          if(type == 2){
            this.baseinfo.assort = '社区志愿服务'
          } else if (type == 4){
            this.baseinfo.assort = '公益基金会'

          }
        }
      });
    },
    afterRead(file) {
      console.log(file, "file");
    },
    //重置数据
    changeType() {
      this.baseinfo.enterTime = "";
      this.baseinfo.blood = "";
      this.baseinfo.hour = "";
      this.baseinfo.money = "";
      this.baseinfo.departmentName = "";
      this.baseinfo.lngTime = "";
      this.baseinfo.image = [];
      // this.tagTimeList = [];
      this.beforeImageList = [];
    },
    //添加时间
    addClick() {
      this.showTime = true;
      this.valueTime = "";
    },
    //确认时间
    onConfirm(time) {
      this.valueTime = moment(time).format("YYYY-MM-DD").replace(/-/g, "");
      this.showPicker = false;
    },
    //确认时间
    onConfirmTwo(time) {
      this.baseinfo.enterTime = moment(time).format("YYYY-MM-DD");
      // .replace(/-/g, "");
      this.showPickerTwo = false;
    },
    //取消选择时间
    cancal() {
      this.showTime = false;
      this.valueTime = "";
    },
    //添加时间
    addTime() {
      if (this.valueTime) {
        if (this.baseinfo.pbType == 3) {
          this.baseinfo.enterTime = this.valueTime;
        } else {
          this.tagTimeList.push(this.valueTime);
          setTimeout(() => {
            this.baseinfo.enterTime = this.tagTimeList.join(",");
          });
        }
        // this.valueTime = "";
        this.showTime = false;
      } else {
        this.showTime = false;
      }
    },
    //删除时间
    delClick(index) {
      this.tagTimeList.splice(index, 1);
      this.baseinfo.enterTime = this.tagTimeList.join(",");
    },
    //提交
    submit() {
      const type = this.baseinfo.pbType;
      const index = this.optionType.find((item) => item.id == type);
      if (type == 1) {
        if (!this.baseinfo.blood) {
          this.$message({
            type: "error", // success error warning
            message: "请输入献血量",
            duration: 2000,
          });
          return;
        }
      } else if (type == 2) {
        if (!this.baseinfo.hour) {
          this.$message({
            type: "error", // success error warning
            message: "请输入活动时长",
            duration: 2000,
          });
          return;
        }
        if (!this.baseinfo.assort) {
          this.$message({
            type: "error", // success error warning
            message: "请选择志愿服务类型",
            duration: 2000,
          });
          return;
        }
      } else if (type == 3) {
        if (!this.baseinfo.departmentName) {
          this.$message({
            type: "error", // success error warning
            message: "请输入公益活动",
            duration: 2000,
          });
          return;
        }
      } else if (type == 4) {
        if (!this.baseinfo.money) {
          this.$message({
            type: "error", // success error warning
            message: "请输入活动金额",
            duration: 2000,
          });
          return;
        }
        if (!this.baseinfo.assort) {
          this.$message({
            type: "error", // success error warning
            message: "请选择公益捐款类型",
            duration: 2000,
          });
          return;
        }
      } else if (type == 5) {
        if (!this.baseinfo.money) {
          this.$message({
            type: "error", // success error warning
            message: "请输入活动金额",
            duration: 2000,
          });
          return;
        }
      } else if (type == 6) {
        if (!this.baseinfo.hour) {
          this.$message({
            type: "error", // success error warning
            message: "请输入活动时长",
            duration: 2000,
          });
          return;
        }
      }

      if (!this.baseinfo.enterTime) {
        this.$toast("请选择公益日期");
        return;
      }

      if (this.baseinfo.image.length < 1) {
        this.$message({
          type: "error", // success error warning
          message: "请上传图片证明",
          duration: 2000,
        });
        return;
      }

      if (index.type == 1) {
        this.showExamine = true;
      } else {
        const params = {
          empNo: this.baseinfo.empNo,
          type: 2,
          activityId: "",
          pbType: this.baseinfo.pbType,
          hour: this.baseinfo.hour,
          blood: this.baseinfo.blood,
          money: this.baseinfo.money,
          enterTime: this.baseinfo.enterTime,
          departmentName: this.baseinfo.departmentName,
          image:
            this.baseinfo.image.length > 0 ? this.baseinfo.image.join(",") : "",
          assort: this.baseinfo.assort,
        };
        console.log(params, "params222");
        apis.apply(params).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "提交成功,请等待后台管理员审核",
              type: "success",
            });
            this.$router.go(-1);
          }
        });
      }
    },
    //取消
    no() {
      this.$router.go(-1);
    },
    //取消提交审批
    cancleExamine() {
      this.showExamine = false;
    },
    //提交审批
    submitExamine() {
      this.showExamine = false;

      const params = {
        empNo: this.baseinfo.empNo,
        type: 2,
        activityId: "",
        pbType: this.baseinfo.pbType,
        hour: this.baseinfo.hour,
        blood: this.baseinfo.blood,
        money: this.baseinfo.money,
        enterTime: this.baseinfo.enterTime,
        departmentName: this.baseinfo.departmentName,
        image:
          this.baseinfo.image.length > 0 ? this.baseinfo.image.join(",") : "",
        auditNo: this.examineInfo.username,
        auditName: this.examineInfo.nickname,
        assort: this.baseinfo.assort,
      };
      apis.apply(params).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.$router.go(-1);
        }
      });
      console.log(params, "params111");
    },
    //根据工号查询上级
    queryParentName() {
      api
        .queryParentNameApi({ userName: this.$store.state.userInfo.username })
        .then((res) => {
          if (res.code == 200) {
            this.examineInfo = res.data;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .container {
    width: 100%;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
}

@media screen and (min-width: 600px) {
  .container {
    width: 276px * $zoom;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
}

.container {
  min-height: 100vh;
  position: relative;
  margin: auto;
  font-size: 1vh;
  background-color: #ffffff;
  padding: 30px;
  .form {
    width: 100%;
    background: #fff;
    border-radius: 25px;
    padding: 30px;
    .fild_label {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      span {
        color: #ff4d4d;
        margin-right: 5px;
        font-size: 32px;
      }
      div {
        color: #0a1629;
        font-weight: bold;
        font-size: 26px;
      }
    }
    .fild_value_upload {
      div {
        display: flex;
        flex-wrap: wrap;
      }
    }
    .fild_value {
      width: 100%;
      margin-bottom: 30px;
      display: flex;
      align-items: center;

      ::v-deep {
        .el-input {
          width: 100%;
        }
        .el-select {
          width: 100%;
        }
        .el-input__inner {
          width: 100%;
          height: 80px;
          border-radius: 16px;
          background: #fafafa;
          border: none;
        }
        .van-cell {
          border-radius: 16px;
          background: #fafafa;
        }
      }
      img {
        margin-left: 20px;
        width: 55px;
        height: 55px;
      }
    }
    .tagList {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 30px;
      font-size: 10px * $zoom;
      margin: 30px 0;
      .tag_item {
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 30px;
      }
      i {
        margin-left: 30px;
      }
    }
  }
}
.footer {
  .btn2 {
    border: none;
    background: none;
    color: #969b9e;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 0 0 30px !important;
    border-radius: 15px;
  }
  .btn1 {
    border: 1px solid #1fbe8a;
    background: #1fbe8a;
    color: #fff;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 60px 0 30px;
    border-radius: 15px;
  }
}
.prove {
  margin-top: 30px;
  color: #ccc;
  font-weight: bold;
  font-size: 26px;
  .img {
    display: flex;
    flex-wrap: wrap;
    img {
      width: 150px;
      height: 230px;
      margin-top: 30px;
      margin-right: 30px;
    }
    img:last-child {
      margin-right: 0;
    }
  }
}
::v-deep {
  .van-dialog__content {
    margin-top: 20px;
  }
  .el-upload--picture-card {
    width: 200px;
    height: 200px;
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-upload-list {
    display: flex;
    li {
      width: 200px;
      height: 200px;
      div {
        width: 100%;
        height: 100%;
        img {
          width: 100% !important;
          height: 100% !important;
          margin-left: 0 !important;
        }
      }
    }
  }
  .dialogImg {
    .el-dialog {
      margin-top: 0 !important;
      width: 100% !important;
      margin: 0 !important;
      .el-dialog__body {
        height: calc(100vh - 55px);
        overflow: auto;
      }
    }
  }
}
.dialog_footer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 30px 0;
  button {
    width: 30%;
    height: 65px;
    font-size: 10px * $zoom;
  }
  button:nth-child(1) {
    border: 1px solid #1fbe8a;
    background: #fff;
    color: #1fbe8a;
  }
  button:nth-child(2) {
    border: 1px solid #1fbe8a;
    background: #1fbe8a;
    color: #fff;
  }
}
.goback {
  margin: 10px 40px 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
.dialog_header_con {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 25px;
  .left {
    color: #282b32;
    font-size: 30px;
  }
}
.examine_con {
  padding: 10px 25px;
  .con_tit {
    color: #666666;
    margin: 20px 0;
  }
  .name {
    text-align: center;
    font-size: 30px;
  }
  .img_con {
    width: 100%;
    display: flex;
    justify-content: center;
    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin-bottom: 10px;
    }
  }

  ::v-deep {
    .van-cell {
      display: flex;
      flex-direction: column;
    }
    .van-field__body {
      background: #fafafa;
      border-radius: 40px;
      height: 85px;
      padding: 0 30px;
      margin-top: 20px;
    }
    .van-icon {
      // margin-right: 20px;
    }
  }
}
.dialog_footer1 {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 30px 0;
  button {
    width: 40%;
    height: 65px;
    font-size: 10px * $zoom;
    border-radius: 15px;
  }
  button:nth-child(1) {
    border: 1px solid #999999;
    background: #fff;
    color: #999999;
  }
  button:nth-child(2) {
    border: 1px solid #1fbe8a;
    background: #1fbe8a;
    color: #fff;
  }
}
</style>
